import { useCallback } from 'react';
import { useIntl } from 'react-intl';
import { mapTabToClassName } from './helpers';

const Tab = ({ url, label, onCallback, type = 'primary', size = 'default', isActive = false, dataValue }) => {
  const { formatMessage } = useIntl();

  const handleCallback = useCallback(
    (event) => {
      event.preventDefault();

      onCallback(dataValue);
    },
    [onCallback]
  );

  const classNames = `integration__tab ${mapTabToClassName['type'][type]}
    ${mapTabToClassName['size'][size]}
    ${mapTabToClassName['state'][isActive]}`;

  return (
    <a href={url} onClick={handleCallback} type={type} className={classNames}>
      {label &&
        formatMessage(
          {
            id: label,
          },
          {
            br: <br />,
          }
        )}
    </a>
  );
};

export default Tab;
